import React from "react";
import { Spinner,SpinnerSize, Icon, mergeStyleSets,getTheme, Modal, IconButton } from "@fluentui/react";
import styles from './subtests.module.css';
import { AccordionItem } from "../common/Accordion";
import { title } from "process";
class Subtest extends React.Component<{
	test:any,
	key:string,
	run:boolean,
	renderAs:string
}>{
	render(): React.ReactNode {
		const test = this.props.test
		if (this.props.renderAs === 'bar'){
			return this.bar()
		}
		if (this.props.renderAs === 'list'){
			return this.list()
		}
		return <div key={this.props.key} style={{display:test?.result?.statusText?'flex':"inline-block", alignItems:'center'}} title={test.title}>
			
				
					{test?.result?.run? <>
						{
						
						(test.result?.result 
						?<Icon iconName="CheckMark" style={{color:'#008000'}}/>
						:<Icon iconName="ChromeClose" style={{color:'#800000'}}/>)}
						<div style={{paddingLeft:'1em'}}>{test.result?.result.statusText}</div>	
					</>
					:(this.props.run ?  <Spinner size={SpinnerSize.xSmall} /> : <></>)
					}
			</div>
	}
	bar(){
		const test = this.props.test;
		let background= '';
		if (test.run) {
			background='#ffb600'
		} else {
			background = test.result ? '#008000' :'#800000'
		}
		return <span style={{display:'block', background:background} }></span>
	}
	list(){
		const test = this.props.test;
		let background= '';
		if (test.run) {
			background='#ffb600'
		} else {
			background = test.result ? '#008000' :'#800000'
		}
		return <div style={{display:'flex'}}>
					
					{test.result?.result 
					?<Icon iconName="CheckMark" title={JSON.stringify(test.result)} style={{color:'#008000', fontSize:'14px', position:'relative'}}/>
					:<Icon iconName="ChromeClose"  title={JSON.stringify(test.result)} style={{color:'#800000', fontSize:'14px', position:'relative'}}/>}
					<div style={{paddingLeft:'0.3em'}}>
					{test.title}
					<span style={{display:'block'}}  dangerouslySetInnerHTML={{__html: test.result?.statusTextL}}  />
					</div>
				</div>
	}
}
interface SubtestsProps {
	tests:any[],
	onUpdate:(tests:any[])=>void,
	pause:boolean,
	pausenGrund:string,
}
interface SubtestsState {
	subtestIndex:number,
	modalOpen:boolean
}
export class Subtests extends React.Component<SubtestsProps,SubtestsState>{
	state: Readonly<SubtestsState>={
		subtestIndex:0,
		modalOpen:false
	}
	componentDidMount(): void {
		this.subtest()
	}
	componentDidUpdate(prevProps: Readonly<SubtestsProps>, prevState: Readonly<SubtestsState>, snapshot?: any): void {
		if(JSON.stringify(prevProps)!==JSON.stringify(this.props) || this.state.subtestIndex!==prevState.subtestIndex) {
			if (!this.props.pause)
			window.setTimeout(()=>this.subtest(),50000);
		}  

	}
	render(): React.ReactNode {
		const theme = getTheme();
		const contentStyles = mergeStyleSets({
			container: {
			  display: 'flex',
			  flexFlow: 'column nowrap',
			  alignItems: 'stretch',
			},
			header: [
			  theme.fonts.xxLarge,
			  {
				justifyContent:"space-between",
				borderTop: `4px solid ${theme.palette.themePrimary}`,
				color: theme.palette.neutralPrimary,
				display: 'flex',
				alignItems: 'center',
				padding: '12px 12px 14px 24px',
			  },
			],
			body: {
			  flex: '4 4 auto',
			  padding: '0 24px 24px 24px',
			  overflowY: 'hidden',
			  selectors: {
				p: { margin: '14px 0' },
				'p:first-child': { marginTop: 0 },
				'p:last-child': { marginBottom: 0 },
			  },
			},
			title: {
				margin: 0
			}
		  });
		return <><p>{this.props.pause?<span title={this.props.pausenGrund}>Pausiert</span> : <span>{this.state.subtestIndex+1} / {this.props.tests.length}</span>}</p>
		<div className={styles[this.props.tests.length > 10 ? 'bar': 'list']} onClick={()=>{
			this.setState({modalOpen:true})
		}}>
			{this.props.tests.map((test:any,index:number)=><Subtest 
														renderAs={this.props.tests.length > 10 || test.test.indexOf('validPage') >=0 ? 'bar': 'list'} 
														key={index+''} 
														run={index===this.state.subtestIndex && !this.props.pause} 
														test={test} 
														/>)}
		</div>
			<Modal
				isBlocking={true}
				isOpen={this.state.modalOpen}
			>

		<div className={contentStyles.header}>
				<h2 className={styles.title}>
					Lorem Ipsum
				</h2>
				<IconButton
				iconProps={{iconName:"Cancel"}}
					ariaLabel="Close popup modal"
					onClick={()=>this.setState({modalOpen:false})}
				/>
				</div>
				<div className={contentStyles.body}>
				<div className={styles.list} >
					
						{this.props.tests.map((test:any,index:number)=><Subtest 
																	renderAs={ 'list'} 
																	key={index+''} 
																	run={index===this.state.subtestIndex && !this.props.pause} 
																	test={test} 
																	/>)}
					</div>
				</div>
			</Modal>
		</> 
	}
	subtest(){
		if (!this.props.pause && this.props.tests){
			let subtestIndex = this.state.subtestIndex+0;
			let tests = this.props.tests;
			let test= (tests[subtestIndex]);
			if (!this.props.pause && (test?.lastRun < (new Date()).getTime()/1000 - test?.intervall || typeof(test?.lastRun)==="undefined") ) {
				if (test){
					fetch('https://tools.vsrv1.webkommunikation24.de/website-monitor/api/test?'+test.test+'.'+test.subtestIndex, {
						body: JSON.stringify(test),
						cache: 'no-cache',
						headers: {
							'content-type': 'application/json',
						},
						method: 'POST',
						mode: 'cors'
					}).then(res=>res.text()).then((res:any)=>{
						res=(JSON.parse(res));
						delete res.statusText;
						let subtestIndex = res.subtestIndex+1;
						let tests = this.props.tests;
						tests[subtestIndex] = res;
						this.props.onUpdate(tests);
						
						this.setNext();
					})
				}
			} else {
				this.setNext();
			}
		} else {
			this.setNext();
		}
	}
	setNext(){
		let subtestIndex = JSON.parse(JSON.stringify(this.state.subtestIndex));
		if (!this.props.pause){
			if (subtestIndex +1 >= this.props.tests.length) {
				subtestIndex=0;
			} else {
				subtestIndex++
			}
		}
		window.setTimeout(()=>this.setState({subtestIndex:subtestIndex}),1000);
	}
}